import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { api } from '../utils/api'
import { DashboardBody, DashData } from '../components/checks/CheckDashboard'
import CheckGrid from '../components/checks/CheckGrid'

// Standalone print view (no app layout): monthly summary for management incl. all charts.
// Opens the browser print dialog once data + charts have rendered → "Save as PDF".
export default function CheckReportPrintPage() {
  const [sp] = useSearchParams()
  const params = { year: sp.get('year'), month: sp.get('month'), range: sp.get('range'), groupId: sp.get('groupId') || undefined, companyId: sp.get('companyId') || undefined }
  const { data: d } = useQuery<DashData>({ queryKey: ['check-report', params], queryFn: () => api.get('/checks/dashboard', { params }).then(r => r.data) })
  const heat = sp.get('heat') || d?.groups[0]?.id
  const ym = `${params.year}-${String(params.month).padStart(2, '0')}`

  useEffect(() => {
    if (!d) return
    const t = setTimeout(() => window.print(), 1500) // let Recharts finish its animation
    return () => clearTimeout(t)
  }, [d])

  if (!d) return <p className="p-8 text-center text-gray-400">กำลังโหลดรายงาน…</p>
  return (
    <div className="p-6 max-w-[1100px] mx-auto bg-white">
      <style>{`@media print { @page { size: A4 landscape; margin: 10mm } body { -webkit-print-color-adjust: exact; print-color-adjust: exact } [data-no-export] { display: none !important } }`}</style>
      <h1 className="text-xl font-bold">รายงานสรุป System Check — {ym}</h1>
      <p className="text-sm text-gray-500 mb-4">ช่วงข้อมูล {d.window.from} ถึง {d.window.to} · พิมพ์เมื่อ {new Date().toLocaleString('th-TH')}</p>
      <DashboardBody d={d}/>
      {heat && <div className="mt-6 break-inside-avoid"><h2 className="font-semibold mb-2">Heatmap {ym}</h2><CheckGrid groupId={heat} month={ym} canRecord={false} compact/></div>}
    </div>
  )
}
